export type {
	Carrier,
	ConditionalRuleEntity,
	ConditionalRulesEntity,
} from "@babackapp/private-api-client/types";

export const createCarrierTagCondition = (
	tagValue: string,
): ConditionalRulesEntity => ({
	operator: "AND",
	rules: [
		{
			id: "tags",
			type: "array",
			operator: "contains",
			value: tagValue,
		},
	],
});

export const extractCarrierTagValue = (
	conditionalRules?: ConditionalRulesEntity | null,
): string | null => {
	if (!conditionalRules?.rules?.length) return null;

	const tagRule = conditionalRules.rules.find(
		(rule: ConditionalRuleEntity) =>
			rule.id === "tags" &&
			rule.type === "array" &&
			rule.operator === "contains",
	) as ConditionalRuleEntity | undefined;

	if (tagRule && typeof tagRule.value === "string") {
		return tagRule.value;
	}

	return null;
};
